import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Navbar2 from "./components/Navbar2"; // Importamos Navbar2
import Footer from "./components/Footer";
import ScrollToTop from "./ScrollToTop";
import Anestesia from "./pages/anestesia/Anestesia";
import DiaCirugia from "./pages/indicaciones/DiaCirugia";
import Previas from "./pages/indicaciones/Previas";
import Recuperacion from "./pages/indicaciones/Recuperacion";
import Preguntas from "./pages/preguntas/Preguntas";
import Inicio from './pages/inicio/Inicio';

function AppWrapper() {
  const location = useLocation();
  
 /* const isInicio = location.pathname === "/" && !location.hash && !location.search;*/
  const isInicio = location.pathname === "/";



  return (
    <>
          <ScrollToTop />
      {/* Navbar2 solo en la página de inicio */}
      {isInicio ? <Navbar2 /> : <Navbar />}
    
      <Routes>
        
        <Route path="/" element={<Inicio />} />
        <Route path="/anestesia" element={<Anestesia/>} />
        <Route path="/indicaciones/dia-cirugia" element={<DiaCirugia />} />
        <Route path="/indicaciones/previas" element={<Previas />} />
        <Route path="/indicaciones/recuperacion" element={<Recuperacion />} />
        <Route path="/preguntas" element={<Preguntas />} />
      </Routes>

      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
